import {
    FETCH_SCHEDULE_AREAS,
    FETCH_ACTIVE_SCHEDULE_AREAS,
    FETCH_SCHEDULE_AREA
} from '../actions/types';

const INITIAL_STATE = {
    items: [],
    activeItems: [],
    detail: null,
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_SCHEDULE_AREAS:
            return {
                ...state,
                items: action.payload?.data || [],
                pagination: {
                    currentPage: Number(action.payload?.current_page || 1),
                    total: Number(action.payload?.total || 0),
                    perPage: Number(action.payload?.per_page || 30)
                }
            };
        case FETCH_ACTIVE_SCHEDULE_AREAS:
            return { ...state, activeItems: action.payload || [] };
        case FETCH_SCHEDULE_AREA:
            return { ...state, detail: action.payload || null };
        default:
            return state;
    }
};
